module.exports = __webpack_public_path__ + "static/img/land15.7549515.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/land15.png
// module id = 876h
// module chunks = 0